import type { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useUrlWithSearchParams } from "../../helpers/routeHelpers";
import { useMctFlags } from "../../helpers/flag-hooks/useMctFlags";

export const ProviderNetworkRoute: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { tmpFeEnableProviderNetwork } = useMctFlags();

  const redirect = useUrlWithSearchParams("/");

  if (tmpFeEnableProviderNetwork) {
    return <>{children}</>;
  }
  // Provider Network not enabled, go to landing page.
  return <Navigate to={redirect} replace />;
};
